import { createFileRoute, Link } from '@tanstack/react-router'
import { buildSeo } from './-lib/seo'
import { createSiteTranslate } from './-lib/site-i18n'

export const Route = createFileRoute('/(public)/privacy')({
	ssr: true,
	head: ({ match }) => {
		const { appLanguage } = match.context
		const t = createSiteTranslate(appLanguage)
		return buildSeo({
			appLanguage,
			path: '/privacy',
			title: t('site:seo.privacy.title'),
			description: t('site:seo.privacy.description')
		})
	},
	component: PrivacyPage
})

function PrivacyPage() {
	const { appLanguage } = Route.useRouteContext()
	const t = createSiteTranslate(appLanguage)

	return (
		<>
			<section className='doc-hero'>
				<div className='wrap'>
					<span className='eyebrow'>
						{t('site:privacy.hero.eyebrow')}
					</span>
					<h1>{t('site:privacy.hero.title')}</h1>
					<p>{t('site:privacy.hero.subtitle')}</p>
					<div className='doc-updated'>
						{t('site:privacy.hero.updated')}
					</div>
				</div>
			</section>

			<div className='wrap doc-body'>
				<aside className='doc-toc'>
					<h4>{t('site:privacy.toc.title')}</h4>
					<a href='#p1'>{t('site:privacy.toc.p1')}</a>
					<a href='#p2'>{t('site:privacy.toc.p2')}</a>
					<a href='#p3'>{t('site:privacy.toc.p3')}</a>
					<a href='#p4'>{t('site:privacy.toc.p4')}</a>
					<a href='#p5'>{t('site:privacy.toc.p5')}</a>
					<a href='#p6'>{t('site:privacy.toc.p6')}</a>
					<a href='#p7'>{t('site:privacy.toc.p7')}</a>
					<a href='#p8'>{t('site:privacy.toc.p8')}</a>
					<a href='#p9'>{t('site:privacy.toc.p9')}</a>
					<a href='#p10'>{t('site:privacy.toc.p10')}</a>
				</aside>

				<div className='doc-content'>
					<div className='callout warn'>
						<strong>{t('site:privacy.callout.title')}</strong>{' '}
						{t('site:privacy.callout.body_prefix')}
						<em>{t('site:privacy.callout.placeholder_word')}</em>
						{t('site:privacy.callout.body_middle')}
						<strong>
							{t('site:privacy.callout.no_legal_advice')}
						</strong>
						{t('site:privacy.callout.body_suffix')}
					</div>

					<section id='p1'>
						<h2>
							<span className='num'>1</span>
							{t('site:privacy.p1.title')}
						</h2>
						<p>
							{t('site:privacy.p1.body_prefix')}
							<a
								className='inl'
								href='mailto:privacy@sealedger.app'
							>
								{t('site:privacy.p1.email')}
							</a>
							{t('site:privacy.p1.body_suffix')}
						</p>
					</section>

					<section id='p2'>
						<h2>
							<span className='num'>2</span>
							{t('site:privacy.p2.title')}
						</h2>
						<ul>
							<li>
								<strong>
									{t('site:privacy.p2.item_account_label')}
								</strong>
								{t('site:privacy.p2.item_account_desc')}
							</li>
							<li>
								<strong>
									{t('site:privacy.p2.item_collection_label')}
								</strong>
								{t('site:privacy.p2.item_collection_desc')}
							</li>
							<li>
								<strong>
									{t('site:privacy.p2.item_technical_label')}
								</strong>
								{t('site:privacy.p2.item_technical_desc')}
							</li>
							<li>
								<strong>
									{t('site:privacy.p2.item_usage_label')}
								</strong>
								{t('site:privacy.p2.item_usage_desc')}
							</li>
						</ul>
						<p>{t('site:privacy.p2.guest_note')}</p>
					</section>

					<section id='p3'>
						<h2>
							<span className='num'>3</span>
							{t('site:privacy.p3.title')}
						</h2>
						<ul>
							<li>{t('site:privacy.p3.item_sync')}</li>
							<li>{t('site:privacy.p3.item_progress')}</li>
							<li>{t('site:privacy.p3.item_features')}</li>
							<li>{t('site:privacy.p3.item_communications')}</li>
						</ul>
					</section>

					<section id='p4'>
						<h2>
							<span className='num'>4</span>
							{t('site:privacy.p4.title')}
						</h2>
						<p>
							{t('site:privacy.p4.body_prefix')}
							<strong>{t('site:privacy.p4.not_stored')}</strong>
							{t('site:privacy.p4.body_suffix')}
						</p>
					</section>

					<section id='p5'>
						<h2>
							<span className='num'>5</span>
							{t('site:privacy.p5.title')}
						</h2>
						<p>{t('site:privacy.p5.body')}</p>
					</section>

					<section id='p6'>
						<h2>
							<span className='num'>6</span>
							{t('site:privacy.p6.title')}
						</h2>
						<p>{t('site:privacy.p6.body')}</p>
					</section>

					<section id='p7'>
						<h2>
							<span className='num'>7</span>
							{t('site:privacy.p7.title')}
						</h2>
						<p>
							{t('site:privacy.p7.body_prefix')}
							<Link className='inl' to='/support'>
								{t('site:privacy.p7.support_link')}
							</Link>
							{t('site:privacy.p7.body_suffix')}
						</p>
					</section>

					<section id='p8'>
						<h2>
							<span className='num'>8</span>
							{t('site:privacy.p8.title')}
						</h2>
						<p>{t('site:privacy.p8.body')}</p>
					</section>

					<section id='p9'>
						<h2>
							<span className='num'>9</span>
							{t('site:privacy.p9.title')}
						</h2>
						<p>{t('site:privacy.p9.body')}</p>
					</section>

					<section id='p10'>
						<h2>
							<span className='num'>10</span>
							{t('site:privacy.p10.title')}
						</h2>
						<p>
							{t('site:privacy.p10.body_prefix')}
							<a
								className='inl'
								href='mailto:privacy@sealedger.app'
							>
								{t('site:privacy.p10.email')}
							</a>
							{t('site:privacy.p10.body_middle')}
							<Link className='inl' to='/support'>
								{t('site:privacy.p10.support_link')}
							</Link>
							{t('site:privacy.p10.body_suffix')}
						</p>
					</section>

					<p style={{ color: 'var(--faint)', fontSize: '13.5px' }}>
						{t('site:privacy.see_also.body_prefix')}
						<Link
							className='inl'
							style={{ color: 'var(--accent)' }}
							to='/terms'
						>
							{t('site:privacy.see_also.terms_link')}
						</Link>
						{t('site:privacy.see_also.body_suffix')}
					</p>
				</div>
			</div>
		</>
	)
}
